import styled from 'styled-components';

const AuthorLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 4px;
  opacity: 0.7;
`;

export default AuthorLabel;
